varying vec2 vUv;
uniform float uTime;
uniform vec3 uTint; // シーン演出用の乗算色（通常は白 = 無効果。オーロラ発動中に緑へ）

void main()
{
    // 中心からの距離
    float distance = length(vUv - 0.5);
    float normalizedDistance = distance / 0.5;
    
    // 円形の境界を定義（0.5以上は完全透明）
    float alpha = 1.0 - smoothstep(0.4, 0.5, distance);
    
    // 複数の色層を作成
    float innerGlow = 1.0 - pow(normalizedDistance, 0.3);
    float middleGlow = 1.0 - pow(normalizedDistance, 0.8);
    float outerGlow = 1.0 - pow(normalizedDistance, 2.0);
    
    // 色の定義
    vec3 coreColor = vec3(1.0, 0.9, 0.7);    // 中心：黄白色
    vec3 innerColor = vec3(1.0, 0.5, 0.1);   // 内側：オレンジ
    vec3 middleColor = vec3(0.3, 0.4, 0.8);  // 中間：薄い青
    vec3 outerColor = vec3(0.02, 0.05, 0.15); // 外側：深い宇宙色
    
    // 時間による揺らぎ効果
    float flicker = 0.9 + 0.1 * sin(uTime * 3.0);
    
    // 色を段階的にミックス
    vec3 finalColor = outerColor;
    finalColor = mix(finalColor, middleColor, outerGlow);
    finalColor = mix(finalColor, innerColor, middleGlow);
    finalColor = mix(finalColor, coreColor, innerGlow * flicker);
    
    // アルファ値を適用して透過効果を作成
    gl_FragColor = vec4(finalColor * uTint, alpha);
}